import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import redeemServicesPaths from '../../helpers/redeemServicesPaths';
import { paginationResponseConverter } from '../../helpers/utils';
import axios from '../RedeemServiceAPI';
import { status200, status200or201 } from '../swagup/status.utils';

const apiErrorParser = errorResponse => {
  const defaultErrorMesage = 'Oops... there was something wrong';
  try {
    if (!isString(errorResponse)) {
      const messages = errorResponse.Messages;
      const currentError = messages[0];
      const rawMessage = currentError.split(': ')[1];

      if (rawMessage?.startsWith('{')) {
        const error = JSON.parse(rawMessage);
        const errorValue = Object.values(error)[0];
        const errorField = Object.keys(error)[0];
        const errorMessage = isArray(errorValue) ? errorValue[0] : errorValue;
        return { status: 'error', message: errorMessage, field: errorField, errorResponse };
      }
      return { status: 'error', message: rawMessage || currentError, errorResponse };
    }
    return { status: 'error', message: errorResponse, errorResponse };
  } catch {
    return { status: 'error', message: defaultErrorMesage, errorResponse };
  }
};

export default {
  list: (id, params) =>
    axios
      .get(redeemServicesPaths.redemptions(id), { status200, params })
      .then(rslt => paginationResponseConverter(rslt.data)),
  create: params =>
    axios
      .post(redeemServicesPaths.createRedemptions, params, status200or201)
      .then(rslt => rslt.data)
      .catch(({ response }) => apiErrorParser(response.data)),
  retry: (id, params) =>
    axios
      .post(redeemServicesPaths.retryRedemptions(id), params, status200or201)
      .then(rslt => rslt.data)
      .catch(({ response }) => apiErrorParser(response.data)),
  delete: params =>
    axios
      .post(redeemServicesPaths.deleteRedemptions, params, status200or201)
      .then(rslt => rslt.data)
      .catch(({ response }) => apiErrorParser(response.data)),
  cancel: (id, params) =>
    axios
      .post(redeemServicesPaths.cancelRedemptions(id), params, status200or201)
      .then(rslt => rslt.data)
      .catch(({ response }) => apiErrorParser(response.data))
};
